import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import { FiUpload, FiX } from 'react-icons/fi';

const ImageUpload = ({ onUpload, onRemove, images, multiple = false }) => {
  const onDrop = useCallback(
    async (acceptedFiles) => {
      const uploadedUrls = [];
      const uploadPreset = 'unsigned_upload'; // Make sure to set your correct preset

      // Iterate over all accepted files and upload them one by one
      for (const file of acceptedFiles) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', uploadPreset);

        try {
          const response = await axios.post(
            'https://api.cloudinary.com/v1_1/dece1wpwn/image/upload',
            formData
          );
          uploadedUrls.push(response.data.secure_url);
        } catch (error) {
          console.error('Error uploading image:', error);
        }
      }

      onUpload(uploadedUrls);
    },
    [onUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/*',
    multiple,
  });

  return (
    <div>
      <div
        {...getRootProps()}
        className={`mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md cursor-pointer hover:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
          isDragActive ? 'border-indigo-500' : 'border-gray-300'
        }`}
      >
        <input {...getInputProps()} />
        <div className="space-y-1 text-center">
          <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
          <div className="flex text-sm text-gray-600">
            <label
              htmlFor="file-upload"
              className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
            >
              <span>{isDragActive ? 'Drop the files here' : 'Upload a file'}</span>
            </label>
            <p className="pl-1">or drag and drop</p>
          </div>
          <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
        </div>
      </div>
      {images && images.length > 0 && (
        <div className="mt-2 flex flex-wrap">
          {images.map((image, index) => (
            <div key={index} className="relative m-1">
              <img src={image} alt={`Uploaded ${index + 1}`} className="w-20 h-20 object-cover rounded" />
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 focus:outline-none"
              >
                <FiX />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageUpload;